// Approved interior sample pages from the real PDF (a small selection only).
export const samplePages: {
  image: string;
  title: string;
  caption: string;
}[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/dfAgUUHi99C9g5MTUQEQDU/01_portada.png',
    title: 'Cover · Six months of planned training',
    caption: '26 weeks, 78 complete sessions and ready-to-use workout cards, organized into six blocks.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/7dK6EEMKABJ8bS55724ZX7/02_calendario_26_semanas.png',
    title: 'The complete 26-week calendar',
    caption: 'Every session A, B and C at a glance, with its focus and the page where you will find it.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/dgxi8HfcMQ3gSDUVCoEcir/03_tecnica_estaciones.png',
    title: 'Station cards · Movement reference',
    caption: 'Start, move and finish for each station, with cues, a common error and a regression.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/6ofGn1kVEhJeacDQg5r4zu/04_sesion_W01-A.png',
    title: 'Session W01-A · Sled & Squat Foundations',
    caption: 'Set-up, warm-up, strength, stations and coaching notes, with Foundation options on every exercise.',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/rGNFwqQGhde2cVyUn1QDrG/05_simulacion_W18-C.png',
    title: 'Session W18-C · Half Simulation 1',
    caption: 'A complete hybrid session with distances, effort levels, timing and space to record results.',
  },
];
